import { render } from "./MaterialLoading.vue?vue&type=template&id=50b7982c&scoped=true"
import script from "./MaterialLoading.vue?vue&type=script&lang=js"
export * from "./MaterialLoading.vue?vue&type=script&lang=js"

import "./MaterialLoading.vue?vue&type=style&index=0&id=50b7982c&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b7982c"]])

export default __exports__